import { useLocalSearchParams } from 'expo-router';
import { FullScreenSpinner, ScreenContainer, View } from 'smoothie';

import TaxDocuments from '../../banking/components/spaces/documents/TaxDocuments';
import { downloadFormerMemberTaxDocument } from '../api/FormerMemberApi';
import { useFormerMemberPortal } from '../hooks/useFormerMemberPortal';

export const FormerMemberBankingTaxForms = () => {
    const { userId } = useLocalSearchParams<{ userId: string }>();

    const { data: portal, isLoading } = useFormerMemberPortal();
    const banking = portal?.banking.find((entry) => entry.userId === userId);

    if (isLoading) {
        return <FullScreenSpinner />;
    }

    return (
        <ScreenContainer title="Tax forms" hasBackButton>
            <View
                height="100%"
                $sm={{ width: 500, marginTop: 32, alignSelf: 'center' }}
            >
                <TaxDocuments
                    taxDocuments={banking?.taxDocuments ?? []}
                    userId={userId}
                    downloadDocument={downloadFormerMemberTaxDocument}
                />
            </View>
        </ScreenContainer>
    );
};
